export const heroData = {
  tag: "每日更新 · 全网同步",
  slogan: "追剧不等待，好剧一网看尽",
  description: "97影视汇集全网最新最热的电视剧资源，覆盖国产剧、韩剧、港台剧及海外热播剧集。每日同步更新，高清流畅播放，让你的追剧体验零延迟、无广告干扰。无论你是热衷古装仙侠、都市情感，还是偏爱悬疑刑侦、甜宠轻喜剧，这里都有你的专属片单。",
  stats: [
    { label: "日更新剧集", value: "200+" },
    { label: "覆盖类型", value: "30+" },
    { label: "高清画质", value: "1080P" },
  ],
};

export const cardsData = [
  {
    title: "古装权谋巨制",
    description: "朝堂之上暗流涌动，权谋较量步步惊心。年度最受期待古装大剧，服化道精良，剧情环环相扣，每一帧都是壁纸级画面。",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20dramatic%20lighting%2C%20ornate%20traditional%20costumes%2C%20royal%20court%20setting%2C%20cinematic%20composition%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20atmospheric%20mist%2C%20elegant%20traditional%20Chinese%20aesthetic%2C%20high%20contrast%20dramatic%20lighting&width=800&height=500&seq=card-guzhuang&orientation=landscape",
    alt: "古装权谋巨制电视剧封面",
  },
  {
    title: "都市甜宠剧场",
    description: "从陌生到心动，从误会到深情。高颜值CP组合演绎最甜都市恋情，轻松下饭，治愈你的每一个夜晚。",
    image: "https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20scene%20with%20warm%20soft%20lighting%2C%20young%20couple%20in%20stylish%20city%20apartment%2C%20cozy%20atmosphere%2C%20golden%20hour%20light%20through%20windows%2C%20contemporary%20fashion%2C%20romantic%20mood%2C%20soft%20focus%20background%2C%20warm%20peach%20and%20cream%20color%20palette&width=800&height=500&seq=card-urban-romance&orientation=landscape",
    alt: "都市甜宠剧场电视剧封面",
  },
  {
    title: "悬疑刑侦剧场",
    description: "烧脑案件层层揭开，真相永远在最后一刻浮出水面。高智商对决，紧凑节奏让你欲罢不能。",
    image: "https://readdy.ai/api/search-image?query=Suspenseful%20crime%20investigation%20scene%20with%20moody%20atmospheric%20lighting%2C%20detective%20examining%20evidence%20in%20dimly%20lit%20room%2C%20dramatic%20shadows%2C%20noir%20aesthetic%2C%20rain-streaked%20windows%2C%20tense%20investigation%20mood%2C%20deep%20amber%20and%20charcoal%20tones&width=800&height=500&seq=card-suspense&orientation=landscape",
    alt: "悬疑刑侦剧场电视剧封面",
  },
  {
    title: "韩剧热播精选",
    description: "韩国顶级编剧与演员阵容，每部都是现象级话题之作。从复仇爽剧到治愈温情，韩流魅力一站式收录。",
    image: "https://readdy.ai/api/search-image?query=Korean%20drama%20scene%20with%20emotional%20intensity%2C%20two%20characters%20in%20dramatic%20confrontation%2C%20stylized%20cinematography%2C%20urban%20Seoul%20backdrop%2C%20soft%20golden%20and%20cool%20neutral%20tones%2C%20cinematic%20shallow%20depth%20of%20field%2C%20emotional%20storytelling%20visual&width=800&height=500&seq=card-kdrama&orientation=landscape",
    alt: "韩剧热播精选电视剧封面",
  },
  {
    title: "年代情感大戏",
    description: "跨越数十年的家族史诗，大时代下小人物的命运沉浮。真实还原时代质感，演技派云集的情感盛宴。",
    image: "https://readdy.ai/api/search-image?query=Vintage%20Chinese%20period%20drama%20scene%20with%20nostalgic%20warm%20tones%2C%20family%20gathering%20in%201980s%20Chinese%20courtyard%2C%20retro%20clothing%20and%20furniture%2C%20golden%20afternoon%20light%2C%20emotional%20family%20moment%2C%20film%20grain%20texture%2C%20sepia%20and%20warm%20amber%20palette&width=800&height=500&seq=card-period-drama&orientation=landscape",
    alt: "年代情感大戏电视剧封面",
  },
  {
    title: "仙侠奇幻世界",
    description: "御剑飞行、三界纷争，顶级特效打造东方奇幻视觉盛宴。虐恋与热血交织，每一帧都是CG大片。",
    image: "https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20scene%20with%20floating%20mountains%20and%20celestial%20palaces%2C%20flowing%20traditional%20robes%20with%20magical%20glow%2C%20mystical%20atmosphere%2C%20soft%20diffused%20lighting%2C%20peach%20blossom%20petals%20floating%2C%20dreamy%20pastel%20and%20gold%20color%20harmony&width=800&height=500&seq=card-xianxia&orientation=landscape",
    alt: "仙侠奇幻世界电视剧封面",
  },
  {
    title: "家庭温情剧场",
    description: "平凡生活里的不平凡故事，家人之间的理解与成长。笑中带泪的烟火人间，适合全家一起观看。",
    image: "https://readdy.ai/api/search-image?query=Warm%20Chinese%20family%20drama%20scene%20with%20cozy%20home%20interior%2C%20family%20members%20sharing%20meal%20around%20dining%20table%2C%20soft%20natural%20window%20light%2C%20lived-in%20apartment%20setting%2C%20warm%20and%20inviting%20atmosphere%2C%20gentle%20cream%20and%20wood%20tones&width=800&height=500&seq=card-family-drama&orientation=landscape",
    alt: "家庭温情剧场电视剧封面",
  },
];

export const carouselData = [
  {
    title: "本周必看：古装剧神仙打架",
    subtitle: "三部顶配古装同期上线，谁的服化道更胜一筹？",
    description: "本周三大古装剧同步上线，从唐朝宫廷到仙侠幻境，每一部都制作精良。追剧党们准备好熬夜刷剧了吗？",
    image: "https://readdy.ai/api/search-image?query=Three%20different%20Chinese%20period%20drama%20scenes%20side%20by%20side%2C%20showing%20palace%20court%2C%20martial%20arts%20battle%2C%20and%20romantic%20garden%20scene%2C%20ornate%20costumes%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20and%20crimson%20palette%2C%20epic%20scale&width=1200&height=600&seq=carousel-weekly-1&orientation=landscape",
    alt: "本周必看古装剧合集",
    badge: "编辑精选",
  },
  {
    title: "韩剧专区：暗黑复仇爽剧TOP5",
    subtitle: "从校园霸凌到财阀争斗，每一部都让人欲罢不能",
    description: "盘点近年最让人上头的韩式复仇爽剧，精心策划的复仇计划、层层递进的反转剧情，一口气刷完根本停不下来。",
    image: "https://readdy.ai/api/search-image?query=Intense%20Korean%20drama%20revenge%20theme%20visual%20with%20dramatic%20contrast%20lighting%2C%20sophisticated%20urban%20setting%2C%20powerful%20character%20in%20dark%20elegant%20attire%2C%20cold%20and%20warm%20light%20contrast%2C%20cinematic%20noir%20aesthetic%2C%20deep%20amber%20accent%20on%20dark%20background&width=1200&height=600&seq=carousel-kdrama-top5&orientation=landscape",
    alt: "韩剧复仇爽剧合集",
    badge: "热门专题",
  },
  {
    title: "悬疑控必入：烧脑神作合集",
    subtitle: "反转再反转，不到最后猜不到真相",
    description: "整理全网评价最高的悬疑剧集，从密室推理到连环案件，每一部都是精心设计的智力游戏。准备好了吗？真相只有一个。",
    image: "https://readdy.ai/api/search-image?query=Suspenseful%20mystery%20drama%20collage%20with%20detective%20board%2C%20red%20strings%20connecting%20clues%2C%20dim%20atmospheric%20lighting%2C%20dramatic%20shadows%2C%20evidence%20photos%2C%20noir%20detective%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20contrast&width=1200&height=600&seq=carousel-mystery&orientation=landscape",
    alt: "悬疑烧脑神作合集",
    badge: "口碑推荐",
  },
  {
    title: "甜度超标：治愈系恋爱剧单",
    subtitle: "高甜预警！这些CP让人血糖飙升",
    description: "精选年度最甜恋爱剧集，从欢喜冤家到日久生情，每一对CP都有独特的化学反应。单身也要好好嗑糖，甜蜜治愈你的日常。",
    image: "https://readdy.ai/api/search-image?query=Soft%20romantic%20drama%20scene%20with%20cherry%20blossom%20petals%2C%20couple%20sharing%20sweet%20moment%20in%20spring%20park%2C%20warm%20golden%20light%2C%20dreamy%20bokeh%20background%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20gentle%20and%20heartwarming%20atmosphere&width=1200&height=600&seq=carousel-romance&orientation=landscape",
    alt: "治愈系恋爱剧单",
    badge: "甜蜜推荐",
  },
  {
    title: "年代剧经典：穿越时光的感动",
    subtitle: "那些年我们一起追过的年代好剧",
    description: "回望那些记录时代变迁的经典年代剧，从改革开放到新世纪，每一部都是一个时代的缩影。老戏骨飙戏，每一帧都是演技教科书。",
    image: "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20period%20drama%20collage%20showing%20different%20eras%20from%201970s%20to%202000s%2C%20retro%20family%20scenes%2C%20vintage%20street%20views%2C%20warm%20sepia%20tones%2C%20old%20photograph%20texture%2C%20emotional%20storytelling%20vibe%2C%20cohesive%20golden%20amber%20palette&width=1200&height=600&seq=carousel-nostalgia&orientation=landscape",
    alt: "年代剧经典合集",
    badge: "经典回顾",
  },
];

export const faqData = [
  {
    question: "97影视的电视剧资源多久更新一次？",
    answer: "所有热播剧集与电视台同步更新，黄金时段播出的剧集通常在当晚即可上线。热门韩剧在韩国首播后24小时内完成字幕制作并发布，国产剧全网第一时间同步。每日平均新增30集以上，确保追剧用户不错过任何精彩瞬间。",
  },
  {
    question: "观看电视剧需要注册或付费吗？",
    answer: "不需要。97影视所有电视剧资源完全免费开放，无需注册账号即可直接播放。我们不设置任何付费墙、VIP专属内容或观看次数限制，真正做到一键追剧零门槛。如未来推出会员增值服务，会提前公告并保持基础观看永久免费。",
  },
  {
    question: "支持哪些设备观看？画质如何？",
    answer: "支持电脑、平板、手机全平台观看，网页端自适应适配各种屏幕尺寸。所有剧集默认提供1080P高清画质，部分热门剧集支持4K超清。播放流畅不卡顿，支持倍速播放、记忆播放进度和断点续看，不同设备间无缝切换。",
  },
  {
    question: "遇到剧集无法播放或内容错误怎么处理？",
    answer: "如遇到播放异常，可尝试刷新页面或切换备用播放线路（通常提供2-3条线路）。若问题持续存在，可通过页面底部的「联系我们」入口提交反馈，技术支持团队通常在工作时间内1小时响应处理。我们也欢迎用户指出剧集信息错误，核实后将立即修正。",
  },
];

export const rankingData = [
  { rank: 1, title: "长安十二时辰", category: "古装悬疑", heat: "9.8", trend: "up" },
  { rank: 2, title: "繁花似锦", category: "都市情感", heat: "9.7", trend: "up" },
  { rank: 3, title: "暗夜追踪", category: "刑侦悬疑", heat: "9.6", trend: "up" },
  { rank: 4, title: "人间星河", category: "年代家庭", heat: "9.5", trend: "stable" },
  { rank: 5, title: "苍兰诀", category: "仙侠奇幻", heat: "9.4", trend: "down" },
  { rank: 6, title: "甜蜜法则", category: "都市甜宠", heat: "9.3", trend: "up" },
  { rank: 7, title: "逆风飞翔", category: "励志成长", heat: "9.2", trend: "new" },
];

export const appData = {
  title: "随时随地，追剧不停",
  description: "97影视移动端适配完美，无需下载APP，手机浏览器打开即可享受与电脑端一致的追剧体验。支持将网站添加到手机桌面，一键直达，追剧更便捷。",
  features: ["全平台适配", "流量优化播放", "一键桌面快捷", "夜间模式护眼"],
  image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20Chinese%20drama%20streaming%20app%20interface%20with%20warm%20dark%20theme%2C%20clean%20UI%20showing%20drama%20thumbnails%2C%20elegant%20minimal%20design%2C%20soft%20ambient%20light%20on%20screen%2C%20modern%20mobile%20phone%20mockup%2C%20cozy%20night%20scene%20background&width=600&height=800&seq=app-mobile&orientation=portrait",
  alt: "97影视移动端追剧体验",
};

export const updatesData = [
  { date: "2026-07-31", content: "《长安十二时辰》大结局已更新，全48集完整上线", tag: "剧集更新" },
  { date: "2026-07-30", content: "韩剧《第七次初吻》第12集更新，中文字幕同步上线", tag: "韩剧更新" },
  { date: "2026-07-29", content: "新增「弹幕讨论」功能公测，欢迎体验全新追剧方式", tag: "功能上线" },
  { date: "2026-07-28", content: "《人间星河》第36集更新，收视率再创新高", tag: "剧集更新" },
  { date: "2026-07-27", content: "暑期追剧季专题上线，精选100部高分剧集推荐", tag: "专题上线" },
  { date: "2026-07-26", content: "《暗夜追踪》豆瓣开分9.1，位列年度国产悬疑榜首", tag: "口碑速报" },
  { date: "2026-07-25", content: "服务器全面升级完成，播放流畅度提升50%", tag: "系统公告" },
  { date: "2026-07-24", content: "《甜蜜法则》甜蜜收官，全36集可一次性畅享", tag: "剧集完结" },
];

export const aboutData = {
  title: "关于我们",
  description: "97影视成立于2023年，是一家专注于电视剧资源聚合与在线播放的综合性追剧平台。我们致力于为中文观众提供最全、最新、最流畅的电视剧在线观看体验。",
  features: [
    { label: "资源覆盖", value: "汇集国产剧、韩剧、港台剧及海外热播剧，类型涵盖古装、都市、悬疑、甜宠、仙侠、年代、家庭等主流品类。" },
    { label: "更新速度", value: "与电视台和流媒体平台同步更新，韩剧字幕组24小时内完成翻译制作，确保用户在第一时间看到最新内容。" },
    { label: "观看体验", value: "全站无广告干扰，1080P高清播放，支持多线路切换、倍速播放和记忆播放进度，适配全平台设备。" },
    { label: "用户至上", value: "永久免费，无需注册即可观看。真诚听取用户反馈，持续优化产品体验，做追剧爱好者最信赖的平台。" },
  ],
};

export const topicsData = [
  { name: "古装权谋", count: "3.2万讨论", color: "bg-primary-100 text-primary-700" },
  { name: "甜宠恋爱", count: "2.8万讨论", color: "bg-accent-100 text-accent-800" },
  { name: "悬疑烧脑", count: "2.5万讨论", color: "bg-secondary-100 text-secondary-800" },
  { name: "韩剧精选", count: "4.1万讨论", color: "bg-primary-100 text-primary-700" },
  { name: "仙侠奇幻", count: "1.9万讨论", color: "bg-accent-100 text-accent-800" },
  { name: "年代经典", count: "2.2万讨论", color: "bg-secondary-100 text-secondary-800" },
  { name: "都市情感", count: "3.5万讨论", color: "bg-primary-100 text-primary-700" },
  { name: "刑侦破案", count: "1.7万讨论", color: "bg-accent-100 text-accent-800" },
  { name: "家庭温情", count: "2.0万讨论", color: "bg-secondary-100 text-secondary-800" },
  { name: "励志成长", count: "1.5万讨论", color: "bg-primary-100 text-primary-700" },
];

export const commentsData = [
  {
    name: "追剧小达人",
    time: "2小时前",
    content: "97影视真的太良心了！更新速度超快，而且完全没有广告，画质还这么清晰。已经安利给身边所有追剧的朋友了，现在大家都在这看。特别是韩剧更新，比别家快太多了！",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20young%20person%20with%20warm%20lighting%2C%20clean%20background%2C%20soft%20features%2C%20friendly%20expression%2C%20modern%20simple%20illustration%20style%2C%20warm%20neutral%20tones&width=80&height=80&seq=avatar-1&orientation=squarish",
  },
  {
    name: "深夜追剧人",
    time: "5小时前",
    content: "终于找到一个不用注册就能直接看剧的网站了！之前到处找资源太累了，现在每晚必刷97影视。倍速播放功能很实用，看年代剧开1.5倍刚刚好。希望一直保持免费！",
    avatar: "https://readdy.ai/api/search-image?query=Minimalist%20avatar%20portrait%20with%20warm%20tones%2C%20simple%20illustration%20style%2C%20gentle%20expression%2C%20clean%20background%2C%20modern%20digital%20art%2C%20subtle%20warm%20lighting&width=80&height=80&seq=avatar-2&orientation=squarish",
  },
  {
    name: "剧荒终结者",
    time: "1天前",
    content: "从微博追过来的，没想到资源这么全！之前想看的几部老剧别的地方都下架了，这里居然还有高清版本。专题推荐也很用心，按照类型和主题整理得明明白白，再也不用担心剧荒了。已收藏！",
    avatar: "https://readdy.ai/api/search-image?query=Simple%20avatar%20portrait%20in%20warm%20minimal%20style%2C%20friendly%20and%20approachable%2C%20clean%20simple%20illustration%2C%20neutral%20warm%20background%2C%20modern%20flat%20design%20aesthetic&width=80&height=80&seq=avatar-3&orientation=squarish",
  },
];

export const mediaData = [
  {
    title: "古装剧服化道大赏：这些细节你注意到了吗？",
    duration: "15:32",
    views: "12.8万",
    image: "https://readdy.ai/api/search-image?query=Exquisite%20Chinese%20historical%20drama%20costume%20display%20with%20intricate%20embroidery%20details%2C%20ornate%20traditional%20robes%20on%20mannequins%2C%20warm%20museum-style%20lighting%2C%20rich%20fabric%20textures%2C%20golden%20and%20crimson%20color%20scheme%2C%20elegant%20presentation&width=800&height=450&seq=media-costume&orientation=landscape",
    alt: "古装剧服化道大赏视频封面",
  },
  {
    title: "2026上半年口碑韩剧盘点：哪部是你的年度最佳？",
    duration: "22:18",
    views: "9.5万",
    image: "https://readdy.ai/api/search-image?query=Korean%20drama%20review%20collage%20style%20visual%20with%20multiple%20drama%20posters%20arranged%20artistically%2C%20warm%20cinematic%20lighting%2C%20professional%20review%20aesthetic%2C%20soft%20amber%20and%20neutral%20tones%2C%20clean%20magazine-style%20layout&width=800&height=450&seq=media-kdrama-review&orientation=landscape",
    alt: "2026上半年口碑韩剧盘点视频封面",
  },
  {
    title: "悬疑剧编剧访谈：如何写出让人猜不到的反转？",
    duration: "18:45",
    views: "7.3万",
    image: "https://readdy.ai/api/search-image?query=Professional%20interview%20setting%20with%20warm%20studio%20lighting%2C%20two%20people%20in%20conversation%2C%20bookshelves%20background%2C%20intellectual%20atmosphere%2C%20soft%20amber%20light%2C%20cozy%20professional%20environment%2C%20cinematic%20interview%20style&width=800&height=450&seq=media-interview&orientation=landscape",
    alt: "悬疑剧编剧访谈视频封面",
  },
  {
    title: "一人分饰多角：国产剧中的演技炸裂时刻",
    duration: "12:56",
    views: "15.1万",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20acting%20showcase%20visual%20with%20split%20screen%20effect%20showing%20different%20character%20expressions%2C%20emotional%20intensity%2C%20theatrical%20lighting%2C%20warm%20spotlight%20effect%2C%20dynamic%20composition%2C%20golden%20and%20deep%20shadow%20contrast&width=800&height=450&seq=media-acting&orientation=landscape",
    alt: "国产剧演技炸裂时刻视频封面",
  },
];

export const featuresData = [
  {
    icon: "ri-shield-check-line",
    title: "安全无广告",
    description: "全站无弹窗、无恶意跳转、无强制注册。纯净观影环境，守护你的追剧体验不被广告打断。",
  },
  {
    icon: "ri-speed-up-line",
    title: "急速更新",
    description: "热播剧与电视台同步上线，韩剧24小时内完成字幕制作，每日更新200+集，追剧快人一步。",
  },
  {
    icon: "ri-4k-line",
    title: "高清画质",
    description: "默认1080P高清播放，热门剧集支持4K超清。多线路智能切换，网络不佳也能流畅观看。",
  },
  {
    icon: "ri-device-line",
    title: "全平台覆盖",
    description: "电脑、平板、手机无缝适配。支持倍速播放、记忆进度、断点续看，多设备间自由切换。",
  },
];

export const indexData = [
  { title: "古装剧大全", count: "156部", description: "朝堂权谋、江湖恩怨、历史传奇" },
  { title: "韩剧精选", count: "283部", description: "复仇爽剧、浪漫甜宠、悬疑烧脑" },
  { title: "都市情感", count: "198部", description: "职场恋爱、都市生活、情感治愈" },
  { title: "悬疑刑侦", count: "132部", description: "密室推理、连环案件、心理对决" },
  { title: "仙侠奇幻", count: "89部", description: "三界纷争、御剑飞行、东方玄幻" },
  { title: "年代经典", count: "104部", description: "家族史诗、时代变迁、岁月情怀" },
  { title: "甜宠剧场", count: "167部", description: "高甜CP、欢喜冤家、浪漫治愈" },
  { title: "家庭温情", count: "95部", description: "家长里短、亲情守护、烟火人间" },
  { title: "港台剧场", count: "78部", description: "TVB经典、台剧精选、华语佳作" },
];

export const contactData = {
  title: "联系我们",
  description: "剧集反馈、内容建议、合作咨询，欢迎通过以下方式与我们取得联系。你的每一条反馈都是我们前进的动力。",
  email: "feedback@97ys.tv",
  wechat: "97yingshi_official",
  tips: [
    "如遇剧集无法播放，请提供剧名和集数，我们将第一时间修复",
    "欢迎推荐优质剧集资源，采纳后将标注贡献者",
    "商务合作请注明来意，我们会在24小时内回复",
  ],
};

export const footerData = {
  description: "97影视 - 汇聚全网最新最热电视剧资源，国产剧、韩剧、港台剧全天候更新。免费高清在线观看，追剧不等待，好剧一网看尽。",
  links: [
    { label: "关于我们", href: "#about" },
    { label: "热门榜单", href: "#ranking" },
    { label: "影迷热评", href: "#comments" },
    { label: "精彩视频", href: "#media" },
    { label: "移动客户端", href: "#app" },
    { label: "联系我们", href: "#contact" },
  ],
};

export const headerNavLinks = [
  { label: "首页", href: "#hero" },
  { label: "关于我们", href: "#about" },
  { label: "热门榜单", href: "#ranking" },
  { label: "影迷热评", href: "#comments" },
  { label: "精彩视频", href: "#media" },
  { label: "移动客户端", href: "#app" },
  { label: "联系我们", href: "#contact" },
];